import { css } from '@emotion/core';
import { tokens } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
var subheading = designTokenFonts.subheading,
  mini = designTokenFonts.mini;
var colours = tokens.colors;
export var agent = {
  name: "xi606m",
  styles: "text-align:center;"
};
export var name = /*#__PURE__*/css(subheading, ";");
export var agentLink = /*#__PURE__*/css("display:block;color:", colours.neutral.heavy.default, ";text-decoration:none;");
export var agency = /*#__PURE__*/css(mini, ";margin-bottom:10px;");
export var avatar = {
  name: "z41yjc",
  styles: "display:inline-block;width:64px;height:64px;"
};
export var awardPill = {
  name: "lw7y9j",
  styles: "display:flex;align-items:center;justify-content:center;margin-bottom:20px;"
};